:host{height:100%;display:flex;flex-direction:column}app-add-edit-facility{flex:1}
/*# sourceMappingURL=add-edit-project-facility.component-SGV7FM5R.css.map */
